
import React from 'react';

interface RadioOption {
  label: string;
  value: string;
}

interface RadioRatingGroupProps {
  label: string;
  name: string;
  value: string | undefined;
  options: RadioOption[];
  onChange: (name: string, value: string) => void;
  required?: boolean;
  disabled?: boolean;
}

const RadioRatingGroup: React.FC<RadioRatingGroupProps> = ({ label, name, value, options, onChange, required = false, disabled = false }) => {
  return (
    <div className="mb-4">
      <label className="block text-brand-stone-700 mb-2 font-medium">
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
        {options.map((option) => (
          <label key={option.value} className={`flex items-center space-x-2 text-brand-stone-600 ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'}`}>
            <input
              type="radio"
              name={name}
              value={option.value}
              checked={value === option.value}
              onChange={(e) => onChange(name, e.target.value)}
              className="h-4 w-4 text-brand-green-600 border-brand-stone-300 focus:ring-brand-green-500"
              disabled={disabled}
            />
            <span>{option.label}</span>
          </label>
        ))}
      </div>
    </div>
  );
};

export default RadioRatingGroup;
